import { ReceiptText } from "lucide-react";
import { useEffect, useState } from "react";

export function OrganizationBillingProfilePanel({ api, profile, onUpdated }) {
  const [draft, setDraft] = useState(profile);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setDraft(profile);
  }, [profile]);

  async function submit(event) {
    event.preventDefault();
    setSaving(true);
    setError("");
    setSaved(false);
    try {
      const updated = await api.updateOrganizationBillingProfile(draft);
      onUpdated?.(updated);
      setSaved(true);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <section className="institution-card institution-billing-profile-card">
      <header>
        <ReceiptText size={20} />
        <div>
          <h2>Datos de facturación</h2>
          <p>Se usan exclusivamente para las compras y suscripciones de IA.</p>
        </div>
      </header>
      <form className="institution-billing-profile" onSubmit={submit}>
        <label>
          Razón social
          <input
            required
            minLength={2}
            maxLength={200}
            value={draft.legalName}
            onChange={(event) => setDraft({
              ...draft,
              legalName: event.target.value,
            })}
          />
        </label>
        <label>
          CUIT / identificación fiscal
          <input
            maxLength={32}
            value={draft.taxId}
            onChange={(event) => setDraft({
              ...draft,
              taxId: event.target.value,
            })}
          />
        </label>
        <label>
          Email de facturación
          <input
            required
            type="email"
            maxLength={320}
            value={draft.contactEmail}
            onChange={(event) => setDraft({
              ...draft,
              contactEmail: event.target.value,
            })}
          />
        </label>
        <div className="institution-billing-profile-actions">
          {error ? <span className="organization-access-error">{error}</span> : null}
          {saved ? <span>Datos guardados.</span> : null}
          <button type="submit" disabled={saving}>
            {saving ? "Guardando…" : "Guardar datos"}
          </button>
        </div>
      </form>
    </section>
  );
}
